'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/DefaultPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const DefaultPhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const DefaultPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={DefaultPhotoSkin} />
);

export default DefaultPhoto;
